'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _RecrutementIcon = _interopRequireDefault(require("Icons/RecrutementIcon"));
var _PreparationEmploiIcon = _interopRequireDefault(require("Icons/PreparationEmploiIcon"));
var _MaintienEmploiIcon = _interopRequireDefault(require("Icons/MaintienEmploiIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class FormationSensibilisationPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Accueil | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recruteurs"
    }, "Recruteurs"), "/ ", /*#__PURE__*/_react.default.createElement("span", {
      className: "blue-text"
    }, "Nos formations et sensibilisation")), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Nos formations et sensibilisation"), /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-circle-decoration c-circle-decoration--blue u-margin-bottom-0"
    }, "Formation des r\xE9f\xE9rents handicap aux besoins particuliers des collaborateurs Asperger."), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-margin-top-0 u-padding-left-15"
    }, "D\xE9finir les besoins, former, accompagner pendant 3 \xE0 6 mois et si besoin, aider au recrutement du candidat."), /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-circle-decoration c-circle-decoration--orange u-margin-bottom-0"
    }, "Formation aux m\xE9thodes d'accompagnement vers l'emploi et d'insertion en entreprise."), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-margin-top-0 u-padding-left-15"
    }, "Nous formons les \xE9quipes de centres m\xE9dico sociaux et les coachs \xE0 nos m\xE9thodes d\u2019accompagnement vers l\u2019emploi et d\u2019insertion dans l\u2019entreprise."), /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-circle-decoration c-circle-decoration--green u-margin-bottom-0"
    }, "Sensibilisation du collectif de travail aux sp\xE9cificit\xE9s du fonctionnement Asperger."), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-margin-top-0 u-padding-left-15"
    }, "Nous intervenons dans les entreprises pour sensibiliser les \xE9quipes \xE0 la personnalit\xE9 des Asperger pour faciliter la mise en place de programmes de recrutement notamment.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-personnesasperger.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h3", {
      className: "txt__border-center"
    }, "Nous pouvons \xE9tudier toute demande de formation et de sensibilisation pour l\u2019adapter \xE0 vos besoins."), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project c-candidat-project--poe"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-association-sans-logo.svg",
      className: "c-candidat-project_img"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "c-title c-title--medium u-margin-bottom-0"
    }, "Notre \xE9quipe"), /*#__PURE__*/_react.default.createElement("p", null, "Nos formateurs travaillent depuis de nombreuses ann\xE9es avec les personnes Asperger."), /*#__PURE__*/_react.default.createElement("p", null, "De formation psychologues du travail, r\xE9f\xE9rents handicap, coachs\u2026 pour certains Asperger eux-m\xEAmes, nos formateurs connaissent le monde de l\u2019entreprise dont ils sont issus pour la plupart.")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue u-margin-top-40",
      href: "/inscription-entreprise"
    }, "Inscrivez-vous gratuitement"))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Ce que nous vous proposons \xE9galement"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid c-parcours-grid--4"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item c-parcours-grid-item--green"
    }, /*#__PURE__*/_react.default.createElement(_RecrutementIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Recrutement et int\xE9gration de candidats"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--orange"
    }, /*#__PURE__*/_react.default.createElement(_PreparationEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--pink"
    }, /*#__PURE__*/_react.default.createElement(_MaintienEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Maintien en emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")))));
    return output;
  }
}
exports.default = FormationSensibilisationPage;
